var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteinPork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "525px",
    height: "525px",
    viewBox: "0 0 525 525",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "protein_pork") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "protein_pork",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#8898AA",
    strokeWidth: 20,
    cx: 263,
    cy: 263,
    r: 240
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-pig-4483352",
    transform: "translate(108.000000, 138.000000)",
    fill: "#8898AA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.494608,4.97564809 C297.637096,22.2494329 289.04343,38.2659631 293.271861,48.7398004 C304.850883,77.409015 300.871724,100.948053 268.687241,109 C263.584842,72.4844394 246.081018,45.8475893 218,30.7861522 C236.950001,7.07435678 272.091558,0.618610607 305.765103,0 C308.318867,-0.043127023 309.852652,2.81532472 308.493555,4.97321766 L308.494608,4.97564809 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.494608,4.97564809 C297.637096,22.2494329 289.04343,38.2659631 293.271861,48.7398004 C304.850883,77.409015 300.871724,100.948053 268.687241,109 C263.584842,72.4844394 246.081018,45.8475893 218,30.7861522 C236.950001,7.07435678 272.091558,0.618610607 305.765103,0 C308.318867,-0.043127023 309.852652,2.81532472 308.493555,4.97321766 L308.494608,4.97564809 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.313601,108.99757 C207.126353,100.945631 203.147178,77.4059628 214.728878,48.7374369 C218.957787,38.2662388 210.368952,22.2444714 199.506068,4.97333332 C198.146967,2.8128153 199.683342,-0.0481254422 202.234533,0 C232.742071,0.560832185 264.459008,5.91490934 284.243678,24.5498471 C286.295699,26.4826207 307.52265,46.5094592 309.303289,48.7374369 C281.222154,63.7916317 278.412616,78.7735087 273.310722,115.293627 L239.313601,108.99757 Z",
    id: "Path",
    transform: "translate(254.151644, 57.646813) scale(-1, 1) translate(-254.151644, -57.646813) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.313601,108.99757 C8.12635255,100.945631 4.14717781,77.4059628 15.7288783,48.7374369 C19.9577874,38.2662388 11.3689524,22.2444714 0.506068494,4.97333332 C-0.853033437,2.8128153 0.683342372,-0.0481254422 3.23453271,0 C33.7420707,0.560832185 65.4590078,5.91490934 85.2436782,24.5498471 C87.2956994,26.4826207 108.52265,46.5094592 110.303289,48.7374369 C82.2221539,63.7916317 79.4126156,78.7735087 74.3107216,115.293627 L40.313601,108.99757 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,199 C144,205.074061 139.076811,210 133,210 C126.925939,210 122,205.076811 122,199 C122,192.925939 126.923189,188 133,188 C139.076811,188 144,192.923189 144,199 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,199 C188,205.074061 183.076811,210 177,210 C170.925939,210 166,205.076811 166,199 C166,192.925939 170.923189,188 177,188 C183.076811,188 188,192.923189 188,199 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.500658,33 C80.8339911,33 55.0506577,77.1732557 55.0506577,132.391304 C55.0506577,154.479576 44,154.479576 44,187.608696 C44,242.502671 80.8333333,287 154.5,287 C228.166667,287 265,242.503328 265,187.608696 C265,154.479576 253.949342,154.479576 253.949342,132.391304 C253.949342,77.173913 228.166667,33 154.499342,33 L154.500658,33 Z M201.930152,218.458126 C191.326756,236.217091 117.680479,236.217091 107.077741,218.458126 C98.2370833,203.659865 115.073205,165.515823 154.503946,165.515823 C193.934687,165.515823 210.771467,203.659865 201.930152,218.458126 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinPork);
export default __webpack_public_path__ + "static/media/protein_pork.09491ee9113d17f882aee30576b96b0c.svg";
export { ForwardRef as ReactComponent };